import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import styles from './CartButton.module.css';

export function CartButton() {
    const navigate = useNavigate();
    const location = useLocation();
    const { itemCount, loading } = useCart();

    // Hide on cart page or when empty
    if (location.pathname === '/cart' || itemCount === 0) {
        return null;
    }

    const handleClick = () => {
        navigate('/cart');
    };

    return (
        <button
            className={styles.cartButton}
            onClick={handleClick}
            disabled={loading}
            aria-label={`Cart with ${itemCount} items`}
        >
            <svg
                className={styles.cartIcon}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <circle cx="9" cy="21" r="1" />
                <circle cx="20" cy="21" r="1" />
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
            </svg>
            <span className={styles.badge}>{itemCount}</span>
        </button>
    );
}
